import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {ConfigurationService} from "../../../services/configuration.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-change-active-version-requests',
  templateUrl: './change-active-version-requests.component.html',
  styleUrls: ['./change-active-version-requests.component.scss']
})
export class ChangeActiveVersionRequestsComponent implements OnInit {

  fetchAllTransitRTimeDataVersionsUrl: string = GlobalConstants.FETCH_ALL_TRANSIT_TIME_DATA_VERSIONS_ENDPOINT;
  activateTransitTimeRequestUrl: string = GlobalConstants.CHANGE_TRANSIT_TIME_VERSION_ENDPOINT;

  changeTransitTimeActiveVersionForm: FormGroup;

  loading = false;
  firstLoad = true;
  records: any[];

  fromCountryCodeOptions: any[];
  transitTimeOptions: string[];

  dataVersions = [];
  currentComponentKeyPlaceholder = [];
  currentWorkingRecord: any;

  items: any;
  dropDownOptions: any;

  defaultRegion: any;
  defaultArc: any;
  countryCodes: any;
  help_messages: any = this.dataService.help_messages;

  user = {};
  hasPermission = false;

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('DataPathUtils') private dataPathUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.changeTransitTimeActiveVersionForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyValue: ['', Validators.required],
      componentKeyPlaceholder: [''],
      transitTimeType: ['', Validators.required]
    });

    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;

    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};

    this.changeTransitTimeActiveVersionForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.changeTransitTimeActiveVersionForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('')
    this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.records = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }


  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.records);
    this.dataVersions = [];

    this.changeTransitTimeActiveVersionForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.changeTransitTimeActiveVersionForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    this.changeTransitTimeActiveVersionForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  private onComponentKeyValueChange() {
    this.dataVersions = [];
  }

  public async render() {
    this.firstLoad = false;
    this.loading = true;
    this.hasPermission = false;
    let requestBody = JSON.parse(JSON.stringify(this.changeTransitTimeActiveVersionForm.value));
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    try {
      this.loading = true;
      this.hasPermission = await this.dataService.checkUserPermissions(requestBody);
      if (this.hasPermission === false) {
        this.loading = false;
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }
    this.requestsService.put(this.fetchAllTransitRTimeDataVersionsUrl, requestBody).subscribe(data => {
      this.loading = false;
      this.dataVersions = data[GlobalConstants.TRANSIT_TIME_DATA_VERSIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  activateTransitTimeVersion(row) {
    this.loading = true;
    let requestBody = JSON.parse(JSON.stringify(row));
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    this.requestsService.put(this.activateTransitTimeRequestUrl, requestBody).subscribe(data => {
      this.loading = false;
      this.render();
      this.toastrService.success(GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS)
    }, error => {
      this.loading = false;
      this.render();
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

}
